import React from 'react';
import classNames from 'classnames';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import DocumentLockedIcon from 'icons/DocumentLocked.icon';
import XIcon from 'icons/X.icon';
import { AGREEMENT_PDF_DROPZONE_OPTIONS, getDroppedFile } from '../../utils';

import './AgreementDocumentPanel.styles.scss';

type AgreementDocumentPanelProps = {
  className?: string;
  fileName?: string;
  isDisabled?: boolean;
  onFileSelect: (file: File) => void;
  onFileRemove: () => void;
};

const AgreementDocumentPanel: React.FC<AgreementDocumentPanelProps> = (
  props,
) => {
  const { className, fileName, isDisabled, onFileSelect, onFileRemove } =
    props;

  const { t } = useTranslation();

  const { getInputProps, open } = useDropzone({
    ...AGREEMENT_PDF_DROPZONE_OPTIONS,
    noClick: true,
    noDrag: true,
    noKeyboard: true,
    disabled: isDisabled,
    onDrop: (accepted, rejections) => {
      const file = getDroppedFile(accepted, rejections);

      if (file) onFileSelect(file);
    },
  });

  const classes = classNames('agreement-document-panel', className);

  return (
    <div className={classes}>
      <p className="agreement-document-panel__title">{t('document')}</p>

      {fileName ? (
        <div className="agreement-document-panel__file">
          <DocumentLockedIcon />
          <p>{fileName}</p>
          <Button
            type="button"
            variant="icon"
            icon={XIcon}
            aria-label={t('agreementRemoveDocument')}
            disabled={isDisabled}
            onClick={onFileRemove}
          />
        </div>
      ) : (
        <Button
          type="button"
          variant="outline"
          className="agreement-document-panel__upload"
          disabled={isDisabled}
          onClick={open}
        >
          {t('agreementUploadPdf')}
        </Button>
      )}

      <input {...getInputProps()} />
    </div>
  );
};

export default AgreementDocumentPanel;
